module.exports = __webpack_public_path__ + "static/img/wenhua10.d07384c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenhua10.jpg
// module id = I8Zh
// module chunks = 1